module.exports = __webpack_public_path__ + "img/reddit.032e9ea6.png";